<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <brand-create-or-update v-model="brand" :errors="errors"></brand-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :fields="fields"
                    name="brand"
                    :buttons="buttons"
                    pagination = "server"
                    search
                    :items-provider="provider"
                    ></v-table>
    </b-card>
</template>

<script>
import {BCard,} from 'bootstrap-vue'
import BrandCreateOrUpdate from './components/BrandCreateOrUpdate.vue'
import VehicleDefinitionsApi from '@/api/vehicle-definitions'
import Additional from '@/utilities/additional.js'

export default {
    components:{
        BCard,
        BrandCreateOrUpdate
    },
    data(){
        return{
            errors:{},
            editing:false,
            loading:false,
            brand:{
                Id:0,
                Name:null,
                Logo:null,
            },
            fields:[
                { name:"Logo",key:"Logo",img:true,tdClass:"text-center"},
                { name:"Marka",key:"Name", thClass:"w-100",sortable:true},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.brand.Id = 0
            this.brand.Name = null
            this.brand.Logo = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.brand.Id = item.Id
            this.brand.Name = item.Name
            this.brand.Logo = item.Logo
            this.$showModal('create-or-update')
        },
        async createOrUpdate(){
            this.loading = true
            let formData =await Additional.ToFormData(this.brand,["Logo"])
            VehicleDefinitionsApi.Brand.CreateOrUpdate(this.editing,formData)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        provider(data){
            return VehicleDefinitionsApi.Brand.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} markasını silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    VehicleDefinitionsApi.Brand.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>